import {CuppaStorage} from "../../cuppa/cuppa.storage";

export class Storages{
	static organization = {name:'ORGANIZATION', store:CuppaStorage.LOCAL, defaultValue:null};
	static auth = {name:'AUTH', store:CuppaStorage.COOKIE, defaultValue:null};
	static user = {name:'USER', store:CuppaStorage.LOCAL, defaultValue:null};
	static loginFormData = {name:'LOGIN_DATA', store:CuppaStorage.LOCAL, defaultValue:{}};
	static roles = {name:'ROLES', storage:CuppaStorage.LOCAL, defaultValue:null};
	static openAssessment = {name:'OPEN_ASSESSMENT', storage: null, defaultValue:{component:null}};
	static lastRefreshTokenTime = {name:'LAST_REFRESH_TOKEN_TIME', store:CuppaStorage.LOCAL, defaultValue:0};
	static dashboard = {name:'DASHBOARD', store:CuppaStorage.LOCAL, defaultValue:null};
	static earlierConversationDate = {name:'EARLIER_CONVERSATION_DATE', store:CuppaStorage.LOCAL, defaultValue:null};
	static reloadConversation = {name:'RELOAD_CONVERSATION', store:null, defaultValue:null};
}
